import type { TypeListFacetValue } from '@/types/list/types.list.find';

export const listFacetValues = (value: TypeListFacetValue): readonly string[] => {
    if (value === null || value === undefined || value === '') return [];
    return typeof value === 'string' ? [value] : value;
};

export default listFacetValues;
